import JsonApi from 'devour-client';
import { ServiceBase } from './ServiceBase';
import { SitePayload } from '../payloads/SitePayload';
import { Dayjs } from 'dayjs';

export class SiteService extends ServiceBase<SitePayload> {
  constructor(jsonApi: JsonApi) {
    const schema = SitePayload.getSchema();

    super(jsonApi, 'site', schema, SitePayload);
  }

  async find() {
    const data = await super.find();
    const sorted = sortSitesByNumber(data);
    return sorted;
  }

  async getAll(siteTypeId?: string) {
    const params = {
      filter: { site_type_id: siteTypeId },
      page: { number: 1, size: 200 },
    };
    const data = await super.find(params);
    const sorted = sortSitesByNumber(data);
    return sorted;
  }

  async getAvailabilities(start: Dayjs, end: Dayjs, siteTypeId?: string, ignoredReservationIds?: string[]) {
    const dateRange = `${start.format('YYYY-MM-DD')}...${end.format('YYYY-MM-DD')}`;
    const availableFilter = { date_range: dateRange, ignored_reservation_ids: ignoredReservationIds };
    const availableFilterString = JSON.stringify(availableFilter);

    const query = {
      filter: { available_between: availableFilterString, site_type_id: siteTypeId },
      page: { number: 1, size: 200 },
    };
    const result = await super.find(query);
    const sorted = sortSitesByNumber(result);
    console.groupCollapsed(`${SiteService.name}.${this.getAvailabilities.name}`);
    console.table(sorted);
    console.groupEnd();

    return sorted;
  }
}

// Workarround due backend is not sorting
function sortSitesByNumber(entities: SitePayload[]) {
  const result = entities
    .map(item => {
      const sorterField = item.siteNumber.replace(/\d+/, (num) => num.padStart(4, '0'));
      return { ...item, sorterField };
    })
    .sort((a, b) => a.sorterField.localeCompare(b.sorterField));

  return result as SitePayload[];
}
